import { CallRouteV1 } from '@frontend/api-call-route';
import { i18next } from '@frontend/i18n';

export const getRepeatPhoneTreeName = (phoneTreeNode: CallRouteV1.Types.Node) => {
  const name = phoneTreeNode.callObject?.primitiveName;
  if (!name) {
    return '';
  }

  return i18next.t(`Repeats “{{phoneTreeName}}”`, { phoneTreeName: name });
};
